// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__16xrM","col":"Table_col__1VHDE","fulfillmentStatus":"Table_fulfillmentStatus__k7kXO","emailCol":"Table_emailCol__1LIAd"};